import { ToggleButton as RACToggleButton, type ToggleButtonProps as RACToggleButtonProps } from "react-aria-components";

export interface ToggleButtonProps extends RACToggleButtonProps {}

export function ToggleButton(props: ToggleButtonProps) {
  return <RACToggleButton {...props} />;
}
